// export default 'http://localhost:8000';
export default 'https://hagd-admin.imperiatec.com';
